import ObjectHelper from 'approot/common/lib/ObjectHelper';

const retrieveStaffInfoResponse = (response) => {
	if (response && !ObjectHelper.isNullOrlengthZore(response.staffInfoResponseArray)) {
		const staffInfo = response.staffInfoResponseArray[0];
		return { staffBranchNumber: staffInfo.staffBranchNumber, staffName: staffInfo.staffName };
	} else {
		return null;
	}
};

const retrieveStaffProfileResponse = (response) => {
	if (response && !ObjectHelper.isNullOrlengthZore(response)) {
		return { staffFullName: response.fullName };
	} else {
		return null;
	}
};

const appLoaderConverter = {
	retrieveStaffInfoResponse,
	retrieveStaffProfileResponse
};
export default appLoaderConverter;
